import withIsVisibleHOC from "@client/hocs/withIsVisible";
import { type ComponentEntitiesSource, type WithId } from "@client/types";
// import Entity from "@client/viewer/layout/Entity/container";
import LayoutContainer from "@client/layout/Container/container";
import Entity from "@client/viewer/layout/Entity/container";
import ErrorBoundary from "@common/controls/ErrorBoundary/component";
import React from "react";

export type MapProps = WithId & {
  componentId: string;
  componentEntityId: string;
  name: string;
  itemIds: string[] | null;
  style?: React.CSSProperties;
};

export default withIsVisibleHOC((props: MapProps) => {
  const source = React.useMemo(
    (): ComponentEntitiesSource => ({
      id: props.componentId,
      type: "component"
    }),
    [props.componentId]
  );

  // NOTE: props.id is the entity id, while we need to render the entities from the component
  return (
    <ErrorBoundary additionalLogInfo={props.componentEntityId}>
      <LayoutContainer id={props.componentEntityId} source={source} style={props.style} viewonly>
        {props.itemIds?.map((x) => (
          <Entity key={x} id={x} source={source} viewonly />
        ))}
      </LayoutContainer>
    </ErrorBoundary>
  );
});
